export const searchFields = `
  id
  idInc
  idVendor
  sk
  type
  version
  bankId
  name
  description
  author
  maturity
  subject
  grade
  dok
  language
  blooms
  excerpt
  interaction
  dueAt
  editorId
  creatorId
  questionIds
  contextIds
  schemaVersion
  createdAt
  updatedAt
  workspaceId
  alignmentIds
  alignments {
    items {
      id
      sk
      name
      abbreviation
      scope
    }
  }
  isUserFavorite
  isUserWatcher
  content {
    canvas {
      id
      type
      interactionType
      content
      config
      scoring
    }
  }
  scoring
  config
  contexts {
    items {
      id
      sk
      type
      idInc
      name
      content {
        body
      }
    }
  }
  file {
    bucket
    name
    key
    size
  }
  __typename
`;

export const searchExams = `
items {
  id
  idInc
  sk
  type
  version
  bankId
  name
  description
  author
  maturity
  subject
  grade
  dok
  language
  blooms
  excerpt
  interaction
  questionIds
  contextIds
  alignmentIds
  schemaVersion
  stats
  statsAt
  createdAt
  updatedAt
  isCreating
  isArchived
  isDeleted
  workspaceId
  isUserPurchased
  __typename
}
nextToken
total
__typename
}
`;

export const searchSchools = `
items {
  id
  sk
  name
  workspaceId
}
`;

export const getPassage = `
id
sk
idInc
name
lexile
lexileMin
lexileMax
wordCount
tags {
  key
  type
  value
}
contextItems {
  id
  sk
  resource {
    alignments {
      items {
        id
        sk
        content
        abbreviation
        sequence
        scope
      }
    }
  }
}
`;
